import { useState } from 'react'

import { useUpdateCompany } from '@/api/company.hook'
import { CompanyStatus } from '@/gen/inventory/v1/company_status_pb'

import { Modal } from '@/components/lemmala-design-system/modal/modal'

import { SUGGEST_TO_REJECT_COMPANY_MODAL_LABELS } from './labels'

export const useSuggestToRejectCompanyModal = (companyId: string, onComplete?: () => void) => {
  const [isOpen, setIsOpen] = useState(false)
  const { mutateAsync: updateCompany, isPending } = useUpdateCompany(companyId)

  const handleClose = () => {
    setIsOpen(false)
    onComplete?.()
  }

  return {
    showModal: () => setIsOpen(true),
    renderModal: () => (
      <Modal
        size='small'
        variant='destructive'
        open={isOpen}
        title={SUGGEST_TO_REJECT_COMPANY_MODAL_LABELS.TITLE}
        cancelButtonText={SUGGEST_TO_REJECT_COMPANY_MODAL_LABELS.CANCEL}
        primaryButtonText={SUGGEST_TO_REJECT_COMPANY_MODAL_LABELS.CONFIRM}
        confirmLoading={isPending}
        onCancel={handleClose}
        onOk={async () => {
          await updateCompany({
            id: companyId,
            status: CompanyStatus.REJECTED,
          })
          handleClose()
        }}
      >
        <p className='text-main-foreground-secondary text-body-default'>
          {SUGGEST_TO_REJECT_COMPANY_MODAL_LABELS.DESCRIPTION}
        </p>
      </Modal>
    ),
  }
}
